import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSProperties, MouseEvent, MouseEventHandler } from 'react';
import { Button } from 'react-bootstrap';

interface LoadingButtonProps {
    size?:  "lg" | "sm";
    variant?: "primary" | "secondary" | "success" | "warning" | "danger" | "light" | "dark" | "info" | "link" | "outline-primary" | "outline-secondary" | "outline-success" | "outline-warning" | "outline-danger" | "outline-light" | "outline-dark" | "outline-info";
    loading: boolean;
    onClick?: MouseEventHandler<HTMLElement>;
    className?: string;
    children: any;
    disabled?: boolean;
    type?: "button" | "submit" | "reset" | undefined;
    style?: CSSProperties | undefined;
}

const LoadingButton = (props: LoadingButtonProps) => {
    const variant = props.variant ? props.variant : "primary";
    const spinner = props.loading ? <>{' '}<span data-testid="button-loading-spinner"><FontAwesomeIcon icon="spinner" spin /></span></> : null;
    const cssClass = props.className ? props.className : undefined;
    const size = props.size ? props.size : undefined;
    const style = props.style ? props.style : undefined;
    const handleClick = (event:MouseEvent<HTMLElement>) => {
        if (props.onClick) {
            event.preventDefault();
            event.stopPropagation();
            props.onClick(event);
        }
    }
    return <Button 
    variant={variant} 
    className={cssClass} 
    size={size} 
    disabled={props.loading || props.disabled}
    onClick={handleClick}
    type={props.type ? props.type : 'button'}
    style={style}
    >{spinner}{props.children}</Button>
};

export default LoadingButton;
